import React, { Suspense, useEffect, useState } from 'react';
import './App.css';

import routes from './config/routes';
import DefaultLayout from './global/components/layouts/DefaultLayout';
import { useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import {isIncludesPath} from "./global/utils/isIncludesUtils";

const publicPaths = [
    '/',
    '/user/login',
    '/user/register',
    '/user/register/*',
    '/unauthorized',
    '/user/forgot-password',
    '/user/reset-password/:hex',
    '/user/register-error',
    '/user/register-success',
    '/user/email-verification/:hex',
    '/user/forgot-password-success',
    '/user/forgot-password-error',
    '/NewLogoPQLarge.png',
    '/newFavicon.png',
];

/**
 * We add these listeners to prevent the default browser behavior when a file is dragged over the window which is to open/download the file
 * The problem arises when a user drags a file over the window and then drops it on a non-file input element.
 * By preventing the default behavior, we can prevent the file from being opened/downloaded EXCEPT when the user drops the file on a file
 * input element (which is handled in the `FileInput` component by setting input.dropzone true).
 */
window.addEventListener("dragenter", function (e) {
  if(!e.target.dropzone) {
    e.preventDefault();
    e.dataTransfer.effectAllowed = "none";
    e.dataTransfer.dropEffect = "none";
  }
}, false);

window.addEventListener("dragover", function (e) {
  if(!e.target.dropzone) {
    e.preventDefault();
    e.dataTransfer.effectAllowed = "none";
    e.dataTransfer.dropEffect = "none";
  }
});

window.addEventListener("drop", function (e) {
  if(!e.target.dropzone) {
    e.preventDefault();
    e.dataTransfer.effectAllowed = "none";
    e.dataTransfer.dropEffect = "none";
  }
});

function App({ initialUser }) {
  const storeUser = useSelector((state) => state.auth.loggedInUser);
  const user = storeUser || initialUser;

  const location = useLocation();
  const history = useHistory();
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    const delay = setTimeout(() => {
      setAuthReady(true);
    }, 100);

    return () => clearTimeout(delay);
  }, []);

  useEffect(() => {
    if (authReady && !user && !isIncludesPath(location.pathname, publicPaths)) {
      localStorage.removeItem('user');
      history.replace('/user/login');
    }
  }, [authReady, user, location.pathname, history]);

  useEffect(() => {
    import('./resources/product/ProductRouter');
    import('./resources/user/UserRouter');
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      fetch('/api/ping', { credentials: 'include' })
          .catch((err) => console.warn("Ping error:", err));
    }, 10 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return (
      <Suspense fallback={<DefaultLayout.Skeleton />}>
        {routes}
      </Suspense>
  );
}

export default App;
